<template>
  <div id="lobby-view">
    <div id="lobby-logistics">
      lobby: {{ lobbyID }} <br />
      ping: {{ ping }} <br />
      attempted: {{ attempted }} <br />
      connected: {{ connected }} <br /> 
    </div>
    <div v-if="!attempted" class="lobby-wrapper">
      attempting to connect to lobby
    </div>
    <div v-if="!connected && attempted" class="lobby-wrapper">
      lobby is private or does not exist
    </div>
    <div v-if="connected && attempted" class="lobby-wrapper">
      <div id="players-wrapper">
        <h1 id="players-title">players</h1>
        <div class="player" v-for="player in lobbyInfo.players" :key="player">
          {{ player }} 
          <span class="player-leader-tag" v-if="player === lobbyInfo.leader">
            (leader)
          </span>
          <span class="player-me-tag" v-if="player == this.socket.id">
            (me)
          </span>
        </div>
      </div>

      <chat-window :socket="socket"></chat-window>

      <h1>game rules</h1>
      <!-- <div id="game-rules-wrapper" v-if="lobbyInfo.leader === this.socket.id"></div> -->
      <div v-if="false"></div>
      <div id="game-rules-wrapper" v-else>
        <div>
          players
          <ul>
            <li v-for="(player, index) in lobbyInfo.gameRules.players" :key="player">
              player {{ index + 1 }}: {{ player }}
            </li>
          </ul>
        </div>
        <div>starting hand size: {{ lobbyInfo.gameRules.startingHandSize }}</div>
        <div>starting health: {{ lobbyInfo.gameRules.startingHealth }}</div>
      </div>

      <div id="lobby-info">{{ lobbyInfo }}</div>
    </div>
  </div>
</template>

<script>
import { io } from 'socket.io-client';
import ChatWindow from '@/components/ChatWindow.vue';

const socket = io();

export default {
  components: { ChatWindow },
  name: 'LobbyView',
  data () {
    return {
      socket: socket,
      lobbyID: -1,
      connected: false,
      attempted: false,
      ping: -1,
      lobbyInfo: null
    }
  },
  methods: {
    connectToLobby (id) {
      this.socket.emit('connect-to-lobby', id);
    },
    getPing () {
      const start = Date.now();
      this.socket.emit('ping', () => {
        this.ping = Date.now() - start;
      });
    }
  },
  mounted () {
    const params = new URLSearchParams(window.location.search);
    const lobbyID = params.get('id');
    this.lobbyID = lobbyID;

    this.getPing();
    setInterval(() => {
      this.getPing();
    }, 1000);

    this.connectToLobby(this.lobbyID);

    this.socket.on('connect', () => {
      console.log('socket connected');
    });

    this.socket.on('join-lobby', connected => {
      this.connected = connected;
      this.attempted = true;

      if (this.connected) this.socket.emit('get-lobby-info', this.lobbyID);
    });

    this.socket.on('lobby-info', lobbyInfo => {
      console.log(lobbyInfo);

      this.lobbyInfo = lobbyInfo;
    });
  },
  beforeUnmount () {
    this.socket.disconnect();
  }
}
</script>

<style scoped>
#lobby-view {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  position: relative;
}

#lobby-logistics {
  position: absolute;
  top: 16px;
  left: 16px;
}

#lobby-info {
  position: absolute;
  bottom: 16px;
  left: 16px;
}

#players-wrapper {
  width: 20%;
  height: 100%;
  padding: 16px;

  position: absolute;
  top: 0px;
  right: 0px;
  background-color: rgba(0, 0, 0, .2);
}

#players-title {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  border-bottom: 2px solid black; 
}

#game-rules-wrapper {
  height: 80%;
  width: 40%;
  padding: 16px;
  background-color: rgba(0, 0, 0, .2);

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}


.player {
  width: 100%;
  height: 1rem;
  padding: 16px;

  display: flex;
  justify-content: center;
  align-items: center;
}

.player-leader-tag {
  color: cornflowerblue;
}

.player-me-tag {
  color: blueviolet;
}

.lobby-wrapper {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>